import type { ComputedRef, MaybeRefOrGetter } from 'vue'
import type { AppBadgeColor } from '../types/types'

type StatusColors<TStatus extends string> = Partial<Record<TStatus, AppBadgeColor>>
type StatusLabels<TStatus extends string> = Partial<Record<TStatus, string>>

interface BadgeFromStatusOptions<TStatus extends string> {
  status: MaybeRefOrGetter<TStatus | null | undefined>
  colors: StatusColors<TStatus>
  labels: MaybeRefOrGetter<StatusLabels<TStatus> | null | undefined>
}

interface BadgeFromStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

export const useBadgeFromStatus = <TStatus extends string>(
  options: BadgeFromStatusOptions<TStatus>,
): BadgeFromStatusReturn => {
  const color = computed<AppBadgeColor>(() => {
    const status = toValue(options.status)
    if (!status) return 'slate'
    return options.colors[status] ?? 'slate'
  })

  const text = computed<string>(() => {
    const status = toValue(options.status)
    if (!status || !options.colors[status]) return ''
    return toValue(options.labels)?.[status] ?? status
  })

  return {
    color,
    text,
  }
}
